module.exports = __webpack_public_path__ + "img/7.70369d21.jpg";